import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import { useState, useEffect } from "react";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { purchasePlanService } from "./purchasePlanService"
import { IPurchasePlanSearch, IPurchasePlanDetail, IPurchasePlanFields } from "./purchasePlanType"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { convertRes2Blob } from "@/utils/exportFile";
import { roleColumnModel } from "@/utils/roleColumn";
export interface IDescTotal {
    totalNum: number,
    totalAmount: number
}
export const usePurchasePlanModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel()
    const { shopCode, shopId, shopType } = shopAndOrg
    const { getHideRoleColumns } = roleColumnModel();
    //切换站点清除缓存
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset();
    }, [shopCode])
    const initSearchParam: IPurchasePlanSearch = {};
    const initDataSource: IPurchasePlanDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM };
    const initDesc = {
        totalNum: 0,
        totalAmount: 0
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IPurchasePlanSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IPurchasePlanDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IPurchasePlanFields>({});
    //列表数据源分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);

    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IPurchasePlanDetail[]>([]);
    const [print, setPrint] = useState<boolean>(false)
    const { user: { roles, supplierCode } } = useGlobalModel();

    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, totalAmount } = item
            newRowsDescTotal.totalNum += +formatNum(totalNum)
            newRowsDescTotal.totalAmount += +formatNum(totalAmount)
        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])

    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IPurchasePlanDetail)
    }, [selectedRowKeys, dataSource])

    const updateSearchParam = (updateParam: IPurchasePlanFields) => {
        // console.log(updateParam)
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const loadData = async (page?: ISearchPage, searchValue: IPurchasePlanSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };

        const searchParams = {
            supplierCode: roles.includes('hd-supplier') ? supplierCode : '',
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        const { retData } = await purchasePlanService.page(searchParams);

        const { records, ...pg } = retData
        const now: any = new Date();
        let newList: any = records.map(item => {
            const newItem: any = { ...item };
            if (roles.includes('hd-supplier')) {
                return newItem
            } else if (newItem.unarrivedNum <= 0) {
                newItem.queryType = 1;
            } else {
                const createTime: any = new Date(newItem.createTime);
                const timeDiff = now - createTime;
                const hoursDiff = timeDiff / (1000 * 60 * 60);
                newItem.queryType = hoursDiff < 48 ? 2 : 3;
            }
            return newItem;
        });
        setPgCfg(transPgToPagination(pg));
        setDataSource(newList);
        loadTotal(searchParams);
    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await purchasePlanService.total(searchParams);
        setDescTotal(statistics)
    }
    //导出
    const exportPurchasePlan = async (searchValue: IPurchasePlanSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            supplierCode: roles.includes('hd-supplier') ? supplierCode : '',
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
            "pageNum": 0,
            "pageSize": 0,
            hidden: getHideRoleColumns("purchasePlan", "主单"),
        }
        try {
            let result = await purchasePlanService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }
    //导出
    const exportPurchasePlanDetail = async (searchValue: IPurchasePlanSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            supplierCode: roles.includes('hd-supplier') ? supplierCode : '',
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
            "pageNum": 0,
            "pageSize": 0,
            hidden: getHideRoleColumns("purchasePlan", "明细"),
        }
        try {
            let result = await purchasePlanService.exportDetail(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result);
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }
    }
    return {
        initPgCfg,
        searchParam,
        dataSource,
        selectedRowKeys,
        selectedRow,
        pgCfg,
        descTotal,
        setSearchParam,
        setDataSource,
        setSelectedRowKeys,
        setSelectedRow,
        setPgCfg,
        updateSearchParam,
        resetSearchParam,
        loadData,
        exportPurchasePlan, exportPurchasePlanDetail,
        setDescTotal,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        print, setPrint
    }
})